








import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseImage from "@/components/BaseImage";
import ContentFeedCover from "@/components/ContentFeedCover";

export default defineComponent({
  name: "MessageItemLinkView",
  components: { BaseImage, ContentFeedCover },
  props: {
    contentSet: { type: Object as () => ContentSet | null },
    isDeleted: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  computed: {
    to(): Location | undefined {
      if (!this.contentSet) return undefined;
      return getProfileUrl(this.contentSet.userId, { feedId: this.contentSet.id });
    },
  },
});
